var map = {
	"./DS.png": 128,
	"./address_image.svg": 129,
	"./alethea.png": 130,
	"./animated_ashutosh.png": 131,
	"./animated_logo.svg": 132,
	"./aws academy.png": 133,
	"./blogs_image.svg": 134,
	"./cloud_infrastructure.svg": 135,
	"./codeInLogo.png": 136,
	"./contactMail.png": 137,
	"./coursera_logo.png": 138,
	"./data_science.svg": 139,
	"./deeplearning_ai_logo.png": 140,
	"./delhivery_logo.png": 141,
	"./developerActivity.svg": 142,
	"./dsc_logo.png": 143,
	"./education.svg": 144,
	"./experience.svg": 145,
	"./feelingProud.svg": 146,
	"./freecopy_logo.png": 147,
	"./fullstack.svg": 148,
	"./gcp_logo.png": 149,
	"./github_logo.png": 150,
	"./googleAssistant.jpg": 151,
	"./googleAssistant.svg": 152,
	"./google_logo.png": 153,
	"./ibm_logo.png": 154,
	"./iiitk_logo.png": 155,
	"./intel_logo.jpg": 156,
	"./iu_logo.png": 157,
	"./jsFramework.svg": 158,
	"./kaggle.png": 159,
	"./legato_logo.png": 160,
	"./manOnTable.svg": 161,
	"./microsoft_logo.png": 162,
	"./mozilla_logo.png": 163,
	"./muffito_logo.png": 164,
	"./nextuLogo.jpg": 165,
	"./nptel_logo.png": 166,
	"./portfolio.gif": 167,
	"./programmer.svg": 168,
	"./projects_image.svg": 169,
	"./pwa.png": 170,
	"./saayaHealthLogo.png": 171,
	"./sajeenthiran.jpeg": 172,
	"./senzmate.png": 173,
	"./stanford_logo.png": 174,
	"./talksCardBack.svg": 175,
	"./talksCardBackAlt.svg": 176,
	"./tiktok_logo.png": 177,
	"./tsg.png": 178,
	"./ui_ux_design.svg": 179,
	"./uki.jpeg": 180,
	"./uki.jpg": 181,
	"./uki.png": 182,
	"./uom_logo.png": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;